module.exports = __webpack_public_path__ + "static/media/plus.b2886400.svg";